var _namedview, _defs, _g, _g2, _mask, _use, _use2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 297 297",
    id: "svg60",
    width: 297,
    height: 297,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _namedview || (_namedview = /*#__PURE__*/React.createElement("namedview", {
    id: "namedview62",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    pageshadow: 2,
    pageopacity: 0,
    pagecheckerboard: 0,
    showgrid: "false",
    zoom: 2.6127946,
    cx: 127.83247,
    cy: 148.5,
    "window-width": 1920,
    "window-height": 1011,
    "window-x": 0,
    "window-y": 0,
    "window-maximized": 1,
    "current-layer": "svg60"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs37"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 71.774203,
    x2: 206.34464,
    y1: 187.32317,
    y2: 53.072091,
    gradientTransform: "matrix(0.92967316,0,0,1.0756468,20.524255,0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#058B7E",
    offset: 0,
    id: "stop2"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#058D80",
    offset: 0,
    id: "stop4"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#058D7F",
    offset: 1,
    id: "stop6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M 127.68,0 C 57.163,0 0,55.791 0,124.61 0,193.432 57.166,249.22 127.68,249.22 l 0.27149,46.914 c 65.606,-37.271 128,-87.019 128,-171.53 0,-68.821 -57.754,-124.61 -128.27,-124.61 z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "i",
    x: 0,
    y: 0,
    width: 1,
    height: 1.0067536
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetInner1",
    id: "feOffset10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1",
    id: "feComposite12",
    k1: 0,
    k4: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.2 0",
    id: "feColorMatrix14"
  })), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M 127.68,0 C 57.163,0 0,55.791 0,124.61 0,193.432 57.166,249.22 127.68,249.22 l 0.27149,46.914 c 65.606,-37.271 128,-87.019 128,-171.53 0,-68.821 -57.754,-124.61 -128.27,-124.61 z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    x: 0,
    y: -0.0067535625,
    width: 1,
    height: 1.0067536
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -2,
    in: "SourceAlpha",
    result: "shadowOffsetInner1",
    id: "feOffset18"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1",
    id: "feComposite20",
    k1: 0,
    k4: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    id: "feColorMatrix22"
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M 127.68,0 C 57.163,0 0,55.791 0,124.61 0,193.432 57.166,249.22 127.68,249.22 l 0.27149,46.914 c 65.606,-37.271 128,-87.019 128,-171.53 0,-68.821 -57.754,-124.61 -128.27,-124.61 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 118.28142,
    x2: 221.34146,
    y1: 135.52251,
    y2: 249.39857,
    gradientTransform: "scale(0.99510904,1.004915)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    id: "stop26"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0,
    offset: 1,
    id: "stop28"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m 55.58,128.11 v 34.239 c 0,9.039 7.3956,16.435 16.435,16.435 h 85.016 c 9.039,0 16.435,-7.3956 16.435,-16.435 v -21.623 l 33.659,33.659 V 128.11 H 55.585 Z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "j",
    x: 0,
    y: 0,
    width: 1.0065987,
    height: 1.059202
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1",
    id: "feOffset32"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    id: "feColorMatrix34"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M 148.20425,0 C 77.687255,0 20.524255,55.791 20.524255,124.61 c 0,68.822 57.166,124.61 127.679995,124.61 l 0.2715,46.914 c 65.60599,-37.271 128,-87.019 128,-171.53 0,-68.821 -57.75401,-124.61 -128.27001,-124.61 z",
    fill: "url(#g)",
    id: "path39",
    style: {
      fill: "url(#g)"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g43",
    transform: "translate(20.524255)"
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#i)",
    xlinkHref: "#d",
    id: "use41",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g47",
    transform: "translate(20.524255)"
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#h)",
    xlinkHref: "#c",
    id: "use45",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    id: "use49",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "311.89,175.62 207.44,81.699 185.11,119.97 58.318,168.56 167.36,281.28 ",
    fill: "url(#f)",
    fillOpacity: 0.21,
    mask: "url(#e)",
    id: "polygon52",
    style: {
      fill: "url(#f)"
    },
    transform: "translate(-8.634745)"
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#000000",
    filter: "url(#j)",
    xlinkHref: "#a",
    id: "use54",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    transform: "translate(16.647499)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fill: "#f6f6f6",
    fillRule: "evenodd",
    xlinkHref: "#a",
    id: "use56",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    transform: "translate(17.1475)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 224.2725,128.11 V 81.704 l -33.659,33.588 v -21.42 c 0,-9.0393 -7.3956,-16.435 -16.435,-16.435 h -85.016 c -9.039,0 -16.435,7.3952 -16.435,16.435 v 34.239 h 151.54 z",
    fill: "#e2e2e2",
    id: "path58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeet);
export default __webpack_public_path__ + "static/media/meet.5bc1c53695b0e8ec0f9694c1a40cf641.svg";
export { ForwardRef as ReactComponent };